<template>
  <van-config-provider :theme-vars="themeVars">
    <router-view />
  </van-config-provider>
</template>

<script setup>
const themeVars = {
  primaryColor: '#4b7efe', // 定制主题色
  buttonPrimaryBackground: '#4b7efe',
}
</script>